<template>
  <div class="positionfixed3">
    <div class="DeepDesign">
      <div class="DeepDesign_content">
        <ImageModal :imageUrl="imageUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageModal from '@c/common/ImageModal/ImageModal.vue';

export default {
  data() {
    return {
      imageUrl: ''
    };
  },
  components: {
    ImageModal
  },
  mounted() {
    
  }
};
</script>



<style>
@import "LogoCenter.css";

.Hearder{ display: none;}
.positionfixed3{ position: fixed; left: 0; bottom: 0; width: 100%; height: calc(100vh); z-index: 50; background: #f7f6fa; overflow: auto;}
.DeepDesign{ background: #e4edf6;}
.DeepDesign_top{ display: flex; align-items: center; justify-content: space-between; padding: 25px 40px; background: #fff;}
.DeepDesign_top .DeepDesign_top_left{ display: flex; align-items: center; cursor: pointer; color: #111;}
.DeepDesign_top .DeepDesign_top_left span{ transform: rotate(180deg); margin-right: 10px; display: inline-block;}
.DeepDesign_top .DeepDesign_top_right{ border-radius: 8px; background: #3662eb; font-size: 16px; color: #fff; padding:5px 20px; cursor: pointer;}
</style>